import React, { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ACCOUNT_INFO,
  PERSONAL_INFO,
  SingleTextField,
  TEXTFIELDS,
} from "../../../../components/form/SignUpTextFields";
import FormSection from "../../../../components/wrappers/FormSection";
import { mandatory } from "../../../../utils/Functions";

export default function EmployeeInfoForm() {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const requiredFields = [
    "username",
    "firstName",
    "lastName",
    "phoneNumber",
    "password",
  ];

  return (
    <Fragment>
      <FormSection title={t("PersonalInfo")}>
        {TEXTFIELDS.map((textfield) => {
          if (textfield.group === PERSONAL_INFO) {
            const label = requiredFields.includes(textfield.register)
              ? mandatory(t(textfield.label))
              : t(textfield.label);

            return (
              <SingleTextField
                key={textfield.register}
                textfield={{ ...textfield, label }}
                t={t}
                errors={errors}
                register={register}
                size="small"
              />
            );
          }
          return null;
        })}
      </FormSection>

      <FormSection title={t("AccountInfo")}>
        {TEXTFIELDS.map((textfield) => {
          if (textfield.group === ACCOUNT_INFO) {
            const label = requiredFields.includes(textfield.register)
              ? mandatory(t(textfield.label))
              : t(textfield.label);

            return (
              <SingleTextField
                key={textfield.register}
                textfield={{ ...textfield, label }}
                t={t}
                errors={errors}
                register={register}
                size="small"
              />
            );
          }
          return null;
        })}
      </FormSection>
    </Fragment>
  );
}
